import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CaptionData } from '../components/addTranslation/services/captionApiService';

interface TranslationState {
  // Step management
  currentStep: number;
  
  // Form data
  referenceId: string;
  selectedCaption: CaptionData | null;
  translatedFileName: string;
  captionsData: CaptionData[];
  
  // Error states
  validationError: string;
  apiError: string;
  
  // Loading states
  isLoading: boolean;
  isTranslating: boolean;
}

const initialState: TranslationState = {
  currentStep: 1,
  referenceId: '',
  selectedCaption: null,
  translatedFileName: '',
  captionsData: [],
  validationError: '',
  apiError: '',
  isLoading: false,
  isTranslating: false,
};

const translationSlice = createSlice({
  name: 'translation',
  initialState,
  reducers: {
    // Step management
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    
    // Form data actions
    setReferenceId: (state, action: PayloadAction<string>) => {
      state.referenceId = action.payload;
    },
    
    setSelectedCaption: (state, action: PayloadAction<CaptionData | null>) => {
      state.selectedCaption = action.payload;
    },
    
    setTranslatedFileName: (state, action: PayloadAction<string>) => {
      state.translatedFileName = action.payload;
    },
    
    setCaptionsData: (state, action: PayloadAction<CaptionData[]>) => {
      state.captionsData = action.payload;
    },
    
    // Error management
    setValidationError: (state, action: PayloadAction<string>) => {
      state.validationError = action.payload;
    },
    
    setApiError: (state, action: PayloadAction<string>) => {
      state.apiError = action.payload;
    },
    
    clearValidationError: (state) => {
      state.validationError = '';
    },
    
    clearApiError: (state) => {
      state.apiError = '';
    },
    
    // Loading states
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    
    setIsTranslating: (state, action: PayloadAction<boolean>) => {
      state.isTranslating = action.payload;
    },
    
    // Reset all state (for restart functionality)
    resetTranslationState: (state) => {
      state.currentStep = 1;
      state.referenceId = '';
      state.selectedCaption = null;
      state.translatedFileName = '';
      state.captionsData = [];
      state.validationError = '';
      state.apiError = '';
      state.isLoading = false;
      state.isTranslating = false;
    }
  },
});

export const translationActions = translationSlice.actions;
export default translationSlice.reducer;